import { HitData } from 'app/model/es/hit-data';
import { Model } from 'app/type/model';
import { WithEsId } from 'app/type/with-es-id';

import { SearchResponse } from './search.response';

export class AsyncSearchResponse<T> {
    public id!: string;
    public isPartial!: boolean;
    public isRunning!: boolean;
    public response!: SearchResponse<T>;

    public constructor(data: Model<AsyncSearchResponse<T>>) {
        Object.assign(this, data);
    }

    public toHitSources(): Array<WithEsId<T>> {
        return this.response.hits.map((hit: HitData<T>) => {
            return {
                esId: hit._id,
                unCorrected: (hit.fields?.unCorrected as boolean[] | undefined)?.[0] ?? false,
                overlapping: (hit.fields?.overlapping as boolean[] | undefined)?.[0] ?? false,
                ...hit._source,
            };
        });
    }

    public lastSort(): Array<number | string> | undefined {
        const hitCount = this.response.hits.length;
        if (0 < hitCount) {
            const lastHit = this.response.hits[hitCount - 1];

            return lastHit.sort;
        }

        return undefined;
    }

    public extractAggregation<A extends number | string>(name: string, defaultVal: A): A {
        return (this.response.aggs[name].value as A) || defaultVal;
    }
}
